import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=3c3933f5&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/K8S-上海阿里云Prod环境-UOTS-Front/frontend/front-uots-simulator/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3933f5"]])

export default __exports__